/**
 * Copyright (c) 2018-present clchart Contributors.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// 以下是 ClChartFixed 的实体定义  --- 固定坐标的尺寸类

// 实际上就是获取某种类型数据，然后横坐标 0 开始排序，永远是数值型，但显示出什么要到对应的数组中找
// 纵坐标根据数据类型，计算最大最小值，然后根据画线类型画出数据线，所有的不同全部在ClChart中处理

import {
    _fillRect,
    _drawRect,
    _setLineWidth,
    _getTxtWidth,
    _drawHline,
    _clearRect,
    _drawBegin,
    _drawEnd
} from './cl.draw'
import {
    CHART_LAYOUT
} from '../cl.chart.res'
import {
    initCommonInfo,
    checkLayout,
    getLineColor
} from './cl.chart.init'

import {
    updateJsonOfDeep,
    copyJsonOfDeep,
    offsetRect,
    inArray,
    isEmptyArray,
    formatInfo,
    inRangeX,
    getSize,
} from '../cl.utils'

import ClChartLine from './cl.chart.line'

import { getValue } from '../datas/cl.data'

/**
 * Class representing ClChartFixed
 * @export
 * @class ClChartFixed
 */

export default class ClChartFixed extends ClChartLine {
    init(cfg, callback) {
        this.callback = callback

        this.rectMain = cfg.rectMain || {
            left: 0,
            top: 0,
            width: 400,
            height: 200
        }
        this.layout = updateJsonOfDeep(cfg.layout, CHART_LAYOUT)
        // console.log(cfg, this.layout);
        
        this.config = copyJsonOfDeep(cfg.config)
        // 这里直接赋值是因为外部已经设置好了配置才会开始初始化
        this.buttons = cfg.config.buttons || []
        // console.log(cfg, this.buttons);
        this.scroll = {
            display: 'none'
        }
        this.childCharts = {}
        
        if (this.config.style  === 'fwindow') {
            this.context = this.father.swimCanvas.context
        }

        // 下面对配置做一定的校验
        this.checkConfig()
        // 再做一些初始化运算，下面的运算范围是初始化设置后基本不变的数据
        this.setPublicRect()
        // 初始化子窗口
        this.childDraws = {}
        this.setChildDraw()
        this.childLines = {}
        this.setChildLines()
        // 初始化按钮
        this.createButtons()
        // 初始化滚动条
        this.setScroll()

    }
    onClear() {
        // console.log('clear ', this.rectMain);
        // _fillRect(this.context, this.rectMain.left - this.scale, this.rectMain.top - this.scale, this.rectMain.width + 2 * this.scale, this.rectMain.height + 2 * this.scale, this.color.back)
        _clearRect(this.context, this.rectMain.left - this.scale, this.rectMain.top - this.scale, this.rectMain.width + 2 * this.scale, this.rectMain.height + 2 * this.scale)
    }
    /**
     * draw all the layers contained in this area
     * @memberof ClChartLine
     */
    onPaint() {
   
        this.data = this.father.getData(this.hotKey)
        // 定位基本参数 计算画图相关信息
        // console.log('--1--', this.context, this.style, this.hotKey, this.data);
        this.locationData()

        this.father.readyData(this.data, this.config.lines)

        _setLineWidth(this.context, this.scale)
        this.drawClear() // 清理画图区

        this.drawChildDraw('GRID') // 先画线格

        // 为画图做准备工作
        this.readyDraw()
        
        this.drawWindow()

        this.drawChildDraw('AXISX')
        this.drawChildDraw('AXISY_LEFT')
        this.drawChildDraw('AXISY_RIGHT')

        this.drawChildDraw('TITLE')
        this.drawChildLines() // 画出所有的线

        this.drawChildCharts()

        if (this.style !== 'fwindow') {
            this.drawCursor()
        }
    }
    // 画图前的准备工作
    /**
     * location data
     * @memberof ClChartLine
     */
    locationData() {
        if (this.data === undefined) return
        const size = getSize(this.data)

        const info = this.linkInfo;

        info.minIndex = 0
        info.maxIndex = size - 1
        info.maxCount = size
        info.unitX = this.scale
        if (this.scale * size < this.rectChart.width) {
            info.unitX = (this.rectChart.width - this.scale * size) / size
        }
        info.spaceX = this.rectChart.width / size - info.unitX
        // 保留一定的间隙
        const minUx = info.unitX / 6
        // console.log(this.name, minUx, info.spaceX);
        if (info.spaceX < minUx) {
            info.spaceX = minUx
            info.unitX = (this.rectChart.width - info.spaceX * size) / size
        }
    }
    getDataRange() {
        return {
            minIndex: this.linkInfo.minIndex,
            maxIndex: this.linkInfo.maxIndex, 
        }
    }
    onMouseWheel(event) {
    }
    /**
     * handle key down
     * @param {Object} event
     * @memberof ClChartLine
     */
    onKeyDown(event) {
        switch (event.keyCode) {
            case 38: // up
            // if (this.linkInfo.minuteCharts > 1) 
            {
                this.callback({
                    event: 'keydown',
                    key: 'ArrowUp',
                    code: 'ArrowUp',
                    keyCode: 38,
                })
            }
            break
        case 40: // down
        // if (this.linkInfo.minuteCharts < this.linkInfo.maxmuCharts) 
            {
                this.callback({
                    event: 'keydown',
                    key: 'ArrowDown',
                    code: 'ArrowDown',
                    keyCode: 40,
                })
            }
            break
        case 37: // left
            this.moveCursor(- 1)
            this.callback({
                event: 'keydown',
                key: ' ',
                code: 'left',
                keyCode: 32,
                rect : this.rectMain,
                mousePos: this.linkInfo.cursor.mousePos,
                data: this.data.value[this.linkInfo.cursor.moveIndex],
                // axisXinfo: this.father.dataLayer.axisXinfo.dataTxt[this.linkInfo.cursor.moveIndex]
            })
            event.break = true;
            break
        case 39: // right
            this.moveCursor(1)
            this.callback({
                event: 'keydown',
                key: ' ',
                code: 'right',
                keyCode: 32,
                rect : this.rectMain,
                mousePos: this.linkInfo.cursor.mousePos,
                data: this.data.value[this.linkInfo.cursor.moveIndex],
                // axisXinfo: this.father.dataLayer.axisXinfo.dataTxt[this.linkInfo.cursor.moveIndex]
            })
            event.break = true;
            break
        case 32: //
            this.callback({
                event: 'keydown',
                key: ' ',
                code: 'space',
                keyCode: 32,
                rect : this.rectMain,
                mousePos: this.linkInfo.cursor.mousePos,
                data: this.data.value[this.linkInfo.cursor.moveIndex],
                // axisXinfo: this.father.dataLayer.axisXinfo.dataTxt[this.linkInfo.cursor.moveIndex]
            })
            event.break = true;
            break
        }
    }
    // ClChart end.
}
